import React from 'react'
import MicroModal from 'react-micro-modal'
import StoryCard from './story/storyCard'
import StoryOverlay from './story/storyOverlay'
import DefaultClasses from '/js/util/defaultClasses'
import { generateSiblingPages } from '/js/util'
import Story from '/img/svg/story'
import DottedLine from '/img/svg/dotted-line'
import OpenArrow from '/img/svg/open-arrow'
import ArrowForward from '/img/svg/arrow'
import ArrowBack from '/img/svg/arrow-back'
import Visible from '/img/svg/visible'
import Invisible from '/img/svg/invisible'

class StorySection extends React.Component {
  state = {
    selectedCardSectionIndex: null,
    selectedCardCardIndex: null,
    overlayInitialized: false,
    hiddenSections: []
  }

  overlayOpen = (
    selectedCardSectionIndex = null,
    selectedCardCardIndex = null
  ) => {
    this.setState({
      overlayInitialized: true,
      selectedCardSectionIndex: selectedCardSectionIndex,
      selectedCardCardIndex: selectedCardCardIndex
    })

    document.body.classList.add('overflow-hidden')
  }

  overlayClose = () => {
    this.setState({
      overlayInitialized: false,
      selectedCardSectionIndex: null,
      selectedCardCardIndex: null
    })

    document.body.classList.remove('overflow-hidden')
  }

  toggleSection = index => {
    const { hiddenSections } = this.state
    const { cards } = this.props.story
    const selectedTitle = cards[index].sectionTitle
    const cardTitles = cards.map(card => card.sectionTitle)
    const sectionsToHide = cardTitles.filter(title => title != selectedTitle)
    const filteredSections = sectionsToHide.filter(section =>
      hiddenSections.includes(section)
    )

    if (filteredSections.length === cards.length - 1) {
      return this.setState({ hiddenSections: [] })
    }

    return this.setState({
      hiddenSections: sectionsToHide
    })
  }

  renderPagination() {
    const { currentPage, routes, title, story } = this.props
    const siblingPages = generateSiblingPages(currentPage, routes)
    const { prevPage, nextPage } = siblingPages

    return (
      <div className="w-full flex flex-wrap justify-between mb-90">
        <a
          data-track-gtm={`Pillar|Previous Page|${prevPage.title}`}
          className={`flex-grow md:flex-grow-0 mr-15 md:mr-0 order-2 md:order-1 ${DefaultClasses.button} ${DefaultClasses.buttonWhite}`}
          href={prevPage.url}
        >
          <ArrowBack className="mr-10" />
          {prevPage.title}
        </a>
        <button
          data-track-gtm={`Pillar|${story.title}|View All`}
          className={`w-full md:w-auto flex-grow md:mx-15 mb-15 md:mb-0 order-1 md:order-2 ${DefaultClasses.button} ${DefaultClasses.buttonWhite}`}
          onClick={() => this.overlayOpen()}
        >
          View All {title}
          <OpenArrow className="ml-10" />
        </button>
        <a
          data-track-gtm={`Pillar|Next Page|${nextPage.title}`}
          className={`flex-grow md:flex-grow-0 order-3 md:order-3 ${DefaultClasses.button} ${DefaultClasses.buttonWhite}`}
          href={nextPage.url}
        >
          {nextPage.title}
          <ArrowForward className="ml-10" />
        </a>
      </div>
    )
  }

  renderCards() {
    const { hiddenSections } = this.state
    const { story, theme } = this.props

    return story.cards.map((section, selectedCardSectionIndex) =>
      section.items.map((card, selectedCardCardIndex) => (
        <StoryCard
          sectionTitle={section.sectionTitle}
          content={card}
          theme={theme}
          hiddenSections={hiddenSections}
          openHandler={() =>
            this.overlayOpen(selectedCardSectionIndex, selectedCardCardIndex)
          }
          key={`card-${card.title}`}
        />
      ))
    )
  }

  renderFilters() {
    const { hiddenSections } = this.state
    const { cards } = this.props.story

    return cards.map((card, index) => (
      <div key={card.sectionTitle}>
        <button
          aria-hidden="true"
          data-track-gtm={`Pillar|Filter|${card.sectionTitle}`}
          onClick={() => this.toggleSection(index)}
          className={`${DefaultClasses.filter} ${
            hiddenSections.includes(card.sectionTitle)
              ? DefaultClasses.filterActive
              : DefaultClasses.filterDefault
          }`}
        >
          {hiddenSections.indexOf(card.sectionTitle) < 0 && (
            <Visible className="mr-15 flex-shrink-0" />
          )}
          {hiddenSections.indexOf(card.sectionTitle) >= 0 && (
            <Invisible className="mr-15 flex-shrink-0" />
          )}
          {card.sectionTitle}
        </button>
        <label htmlFor={`story-filter-${index}`} className="screenreader">
          {card.sectionTitle}
        </label>
        <input
          type="checkbox"
          data-track-gtm={`Pillar|Filter|${card.sectionTitle}`}
          className="screenreader"
          id={`story-filter-${index}`}
          onClick={() => this.toggleSection(index)}
        />
      </div>
    ))
  }

  render() {
    const { story, theme, icon, title } = this.props
    const {
      overlayInitialized,
      selectedCardSectionIndex,
      selectedCardCardIndex
    } = this.state

    if (!story) {
      return null
    }

    return (
      <section
        data-label="story-section"
        className={`relative pt-100 md:pt-30 pb-32 md:pb-100 bg-jet-black border-t-16 ${theme.borderColor}`}
      >
        <div className="absolute top-0 w-100 h-100 -ml-50 -mt-66 left-half rotate-45 bg-white">
          <div
            className={`absolute top-25 right-10 w-65 h-65 -rotate-45 ${theme.textColor}`}
            aria-hidden="true"
          >
            <Story />
          </div>
        </div>
        <div className="container px-25">
          <div className="mx-auto mb-25 md:mb-35 flex justify-between text-white">
            <h2 className="text-24 md:text-36 uppercase font-condensed mr-10">
              {story.title}
            </h2>
            <button
              className={`${DefaultClasses.button} ${DefaultClasses.buttonWhite}`}
              onClick={() => this.overlayOpen()}
              data-track-gtm={`Pillar|${story.title}|View All`}
            >
              View All
              <OpenArrow className="ml-10" />
            </button>
          </div>
          <div className="relative">
            <DottedLine className="text-white mb-32 w-full max-h-3" />
            <div className="absolute w-full flex justify-center -top-13">
              <h3 className="uppercase font-condensed text-white text-14 bg-jet-black px-32">
                Filter By
              </h3>
            </div>
            <fieldset className="mb-15" aria-controls="story-cards">
              <div className="flex flex-wrap justify-center">
                {this.renderFilters()}
              </div>
            </fieldset>
          </div>
        </div>
        <div
          className="flex flex-col md:flex-row flex-wrap justify-center lg:justify-start items-center card-container-md:w-card-md card-container-lg:w-card-lg card-container-xl:w-card-xl mx-auto"
          id="story-cards"
        >
          {this.renderCards()}
        </div>

        <div className="container px-25">
          <DottedLine className="text-white mt-10 mb-32 w-full max-h-3" />
          {this.renderPagination()}
        </div>

        <MicroModal
          open={overlayInitialized}
          handleClose={() => this.overlayClose()}
          closeOnEscapePress={true}
          disableFirstElementFocus={true}
          closeOnOverlayClick={true}
          modalOverlayClassName={`animate translate-y-fade animation-slow z-70`}
          children={handleClose => (
            <StoryOverlay
              selectedCardSectionIndex={selectedCardSectionIndex}
              selectedCardCardIndex={selectedCardCardIndex}
              icon={icon}
              story={story}
              theme={theme}
              title={title}
              handleClose={this.overlayClose}
            />
          )}
        />
      </section>
    )
  }
}

export default StorySection
